import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "@/components/AuthShell";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { FindoSpinner } from "@/components/FindoSpinner";

export default function Reset() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const isInvite = params.get("invite") === "1";
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api("/auth/reset", { method: "POST", body: { token, new_password: pwd }, auth: false });
      toast.success(isInvite ? t("hc.accountActivatedPleaseLogIn") : t("hc.passwordResetPleaseLogIn"));
      navigate("/auth/login");
    } catch (err) {
      toast.error(err.message || t("hc.invalidOrExpiredLink"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell
      title={isInvite ? t("hc.activateMyAdminAccount") : t("a.resetTitle")}
      subtitle={isInvite ? t("hc.chooseYourPasswordToAccess") : t("a.resetSub")}>
      {!token ? (
        <div className="text-sm text-slate-600" data-testid="reset-notoken">
          <Link to="/auth/forgot" className="font-semibold text-findo-indigo">{t("a.forgotTitle")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div>
            <Label htmlFor="pwd">{t("a.newPassword")}</Label>
            <PasswordInput id="pwd" required minLength={6} value={pwd} onChange={(e) => setPwd(e.target.value)}
              placeholder={t("a.min6")} className="mt-1.5 h-11 rounded-xl" data-testid="reset-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 rounded-xl font-semibold" data-testid="reset-submit">
            {loading ? <span className="inline-flex items-center gap-1.5"><FindoSpinner size={16} />{t("a.sending")}</span> : (isInvite ? t("hc.activateMyAccount") : t("a.reset"))}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
